var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.type === null)?_c('span',[_vm._v("--")]):(_vm.type === 'plain')?_c('span',[_vm._v(_vm._s(_vm.value))]):(_vm.type === 'guid')?_c('span',[_c('GuidConceal',{attrs:{"value":_vm.value}})],1):(_vm.type === 'complex')?_c('span',[_c('JsonViewer',{attrs:{"value":_vm.value}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }